module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-container"
  }, [_c('ul', _vm._l((_vm.lineArr), function(line, index) {
    return _c('li', {
      staticClass: "line-item"
    }, [_c('span', {
      staticClass: "line-number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('pre', {
      staticClass: "line-content"
    }, [_vm._v(_vm._s(line === '' ? ' ' : line))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0553077e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lineNumber.vue
// module id = 355
// module chunks = 0